/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { useNavigate } from 'react-router-dom';
import LaborInformation from './LaborInformation';

export default function LaborInformationPage() {
    const navigate = useNavigate();
    const handleBackClick = () => navigate('/contractor/company');
    const handleNextClick = () => navigate('/contractor/documents');

    return (
        <LaborInformation
            handleBackClick={handleBackClick}
            handleNextClick={handleNextClick}
        />
    );
}
